// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ejl0mow0d4_RXP8ivk2v{background-color:var(--border-neutral-default);width:100%;height:1px}.LufP6H8g4NRMrChBZe8s{width:calc(100% + 8px);margin:4px 0 4px -4px}.mjnsGaLVbMUo9Phfv8HS{white-space:nowrap;text-align:center;background-color:unset;gap:10px;height:auto;display:flex}.mjnsGaLVbMUo9Phfv8HS:before,.mjnsGaLVbMUo9Phfv8HS:after{border-top:thin solid var(--gray-a-25);content:"";align-self:center;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"divider": `Ejl0mow0d4_RXP8ivk2v`,
	"dropdown": `LufP6H8g4NRMrChBZe8s`,
	"text": `mjnsGaLVbMUo9Phfv8HS`
};
export default ___CSS_LOADER_EXPORT___;
